module.exports = __webpack_public_path__ + "images/emoji/green_apple.b1b60c4d9c2da251753d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/green_apple.png
// module id = JXwe
// module chunks = 24